import Link from "antd/es/typography/Link";

import {
  AutoComplete,
  AutoCompleteProps,
  Button,
  DatePicker,
  Divider,
  InputNumber,
  Modal,
  Table,
} from "antd";
import { useState } from "react";
import {
  getProductsAssembleTime,
  getProductsSeniority,
} from "../../../utils/helpers/ticketHelpers";
import Column from "antd/es/table/Column";
import { useQuery } from "react-query";
import { AuthenticationState, UserInterface } from "../../../interfaces/users";
import { api } from "../../../config";
import { useSelector } from "react-redux";
import { addHours } from "date-fns";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { Input } from "antd";
import { formatPhoneNumber } from "../../../utils";
import { useModal } from "../../../utils/hooks/useModal";
import { ProductGroupViewModel, ProductViewModel } from "../../../interfaces";
import { Comment } from "../../Assembly/TicketModal/comments";
import { AddonsForm } from "../Addons/AddonsForm";
const { TextArea } = Input;
interface ScheduleAssembleEventProps {
  initialTicket: any;
  onSchedule: (event: any) => void;
  onCancel: () => void;
  defaultDate?: Date;
  onAfterSchedule?: (ticket: any) => void;
}

const ScheduleAssembleEvent = ({
  initialTicket,
  onSchedule,
  onCancel,
  defaultDate,
  onAfterSchedule,
}: ScheduleAssembleEventProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const { data: users } = useQuery<UserInterface[]>("users-assemble", () =>
    api(token).get(`users?moduleName=ASSEMBLE_APP&permission=USER`)
  );

  const [eventDate, setEventDate] = useState<any>(
    defaultDate ? dayjs(defaultDate) : null
  );
  const [ticket, setTicket] = useState(initialTicket);
  const [ownerId, setOwnerId] = useState<any>(ticket?.ownerId);

  const [options, setOptions] = useState<AutoCompleteProps["options"]>([]);

  const [ticketPeriod, setTicketPeriod] = useState<any>(
    getProductsAssembleTime(ticket.products)
  );
  const [quilometragem] = useState<any>(0);

  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);

  const [observation, setObservation] = useState<any>(ticket?.notes);

  const { data, refetch } = useQuery({
    queryFn: () => api(token).get(`product-groups/${ticket.id}`),
  });

  const scheduleTicket = async (
    ticket: any,
    startDate: any,
    ownerId: number,
    notes?: string,
    quilometragem?: number
  ) => {
    if (!ownerId || !startDate) {
      return;
    }

    try {
      const response = await api(token).post(`events/assemble`, {
        description: ticket.title,
        start: new Date(startDate),
        end: addHours(new Date(startDate), ticketPeriod),
        assemblerId: ownerId,
        fieldReportId: ticket.id,
        notes,
      });

      toast.success("Montagem agendada com sucesso");
      onSchedule(response);
      onAfterSchedule?.(ticket);
    } catch (error: any) {
      console.log(error);
      toast.error(
        error?.response?.data?.error ?? "Ocorreu um erro ao agendar a Montagem"
      );
    }
  };

  const getPanelValue = (text: string) => {
    return users
      ?.filter(
        (user) =>
          user?.seniorityId <= getProductsSeniority(ticket.products) &&
          !isNaN(user?.seniorityId)
      )
      .filter((user) =>
        user.fullName.toLowerCase().includes(text.toLowerCase())
      )
      .map((user) => ({ value: user.fullName, label: user.fullName }));
  };

  const { isOpen, onOpen, onClose } = useModal();
  const [groupName, setGroupName] = useState("");
  const [createGroupLoading, setCreateGroupLoading] = useState(false);
const handleClose = () => {
  setGroupName("");
  setSelectedRowKeys([]);
  onClose()
}
  const createGroup = async () => {
    try {
      setCreateGroupLoading(true);
      const createdGroup = await api(token).post("product-groups/", {
        name: groupName,
        fieldReport: {
          connect: { id: ticket.id },
        },
        fieldReportProducts: {
          connect: selectedRowKeys.map((selected: number) => ({
            id: selected,
          })),
        },
      });

      setTicket(createdGroup);
      setGroupName("");
      setSelectedRowKeys([]);
      refetch()
      onClose();
    } catch (error) {
      toast.error("Ocorreu um erro ao criar o grupo");
    } finally {
      setCreateGroupLoading(false);
    }
  };
  const handleDeleteProductGroup = async (productGroupId: number) => {
    if (!window.confirm("Tem certeza de que deseja excluir o Grupo?")) return;
    try {
      setCreateGroupLoading(true);
      const {fieldReport } = await api(token).delete(`product-groups/${productGroupId}`);
      setTicket(fieldReport)
      refetch()
    } catch (error) {
      toast.error("Ocorreu um erro ao excluir o Grupo");
    } finally {
      setCreateGroupLoading(false);
    }
  };
  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleClose}
        onCancel={handleClose}
        loading={createGroupLoading}
        onOk={createGroup}
      >
        <h4>Criar Grupo de Produtos</h4>
        <label style={{marginTop: '30px'}}>Nome do Grupo:</label>
        <Input
          value={groupName}
          
          onChange={(e) => setGroupName(e.target.value)}
        />
      </Modal>

      <h4>
        {" "}
        <Link href={`/montagem?id=${ticket.id}`} underline target="_blank">
          {ticket?.title}
        </Link>
      </h4>
      <p>Cliente: {ticket?.client?.name}</p>
      <p>ID Venda: {ticket?.saleId}</p>
      <p>
        <b className="text-md">Contato:</b>
        <br />
        <div>Telefone: {formatPhoneNumber(ticket?.client.phoneNumber)}</div>
        <div>
          Telefone Alternativo:{" "}
          {formatPhoneNumber(ticket?.client.alternativePhoneNumber)}
        </div>
      </p>
      <p>
        <b className="text-md">Endereço:</b>
        <br />
        <div>
          Rua: {ticket?.client.deliveryAddress?.street}{" "}
          {ticket?.client.deliveryAddress?.add
            ? `(${ticket?.client.deliveryAddress?.add})`
            : ""}
        </div>
        <div>Bairro: {ticket?.client.deliveryAddress?.neighbor}</div>
        <div>Cidade: {ticket?.client.deliveryAddress?.city}</div>
        <div>Estado: {ticket?.client.deliveryAddress?.state}</div>
        <div>CEP: {ticket?.client.deliveryAddress?.zipCode}</div>
      </p>
      <Divider></Divider>

      {!!data?.length && (
        <>
          <h4>Grupos</h4>
          <Table
            loading={createGroupLoading}
            dataSource={data.map((item: ProductGroupViewModel) => ({...item, key: item.id}))}
            pagination={false}
            expandable={{
              expandedRowRender: (row) => (
                <Table pagination={false} dataSource={row.fieldReportProducts}>
                  <Column
                    title="Produto"
                    key="product"
                    dataIndex={["product", "description"]}
                  />
                </Table>
              ),
            }}
          >
            <Column
              title="Nome do Grupo"
              key="groupName"
              dataIndex={["name"]}
            />
            <Column
              title="Ações"
              render={(row) => (
                <>
                  <Button onClick={() => handleDeleteProductGroup(row.id)}>
                    Excluir
                  </Button>
                </>
              )}
            />
          </Table>
          <Divider></Divider>
        </>
      )}

      <h4>Produtos</h4>
      <Button disabled={selectedRowKeys.length < 2} onClick={onOpen}>Criar Grupo</Button>
      <Table
        rowSelection={{
          type: "checkbox",
          selectedRowKeys,
          onChange: (row) => setSelectedRowKeys(row)
        }}
        dataSource={ticket?.products
          .filter((product: ProductViewModel) => !product.ProductGroup)
          .map((product: any) => ({ ...product, key: product.id }))}
        pagination={false}
        className="mb-8"
      >
        <Column
          title="Descrição"
          dataIndex={["product", "description"]}
          key="description"
        />
        <Column title="Quantidade" dataIndex="quantity" key="quantity" />
        <Column
          title="Senioridade"
          dataIndex={["product", "seniority", "name"]}
          key="seniority"
        />
        <Column
          title="Tempo de montagem"
          dataIndex={["product", "assemblyTime"]}
          render={(assemblyTime: number) =>
            `${assemblyTime} ${assemblyTime > 1 ? "Horas" : "Hora"}`
          }
          key="assemblyTime"
        />
      </Table>
      <div className="w-full flex items-center justify-between mb-5 mx-auto">
        <div className="flex flex-col items-center justify-center gap-2 ">
          Montador:
          <AutoComplete
            options={options}
            style={{ width: 200 }}
            onSelect={(value) =>
              setOwnerId(users?.find((user) => user.fullName === value)?.id)
            }
            defaultValue={users?.find((user) => user.id === ownerId)?.fullName}
            onSearch={(text) => setOptions(getPanelValue(text))}
            placeholder="Busque o Montador"
          />
        </div>
        <div className="flex flex-col items-center justify-center gap-2 w-44">
          Tempo de Montagem:
          <InputNumber
            min={1}
            max={64}
            value={ticketPeriod}
            onChange={(value) => {
              if (value) {
                setTicketPeriod(value);
              }
            }}
            addonAfter="Horas"
          />
        </div>
        <div className="flex flex-col items-center justify-center gap-2">
          Data do agendamento:
          <DatePicker
            showTime
            format="DD/MM/YY HH:mm"
            minuteStep={5}
            value={eventDate}
            disabledDate={(date) => date.isBefore(new Date())}
            disabledTime={() => ({
              disabledHours: () => [0, 1, 2, 3, 4, 5, 22, 23],
            })}
            onChange={(value) => {
              if (
                value &&
                (value.isAfter(new Date()) || value.isSame(new Date()))
              ) {
                setEventDate(value);
              } else {
                if (value) {
                  alert("Data inválida");
                }
                setEventDate(null);
              }
            }}
          />
        </div>
      </div>
      <AddonsForm ticketAdditions={ticket.PaymentAdditions} ticketId={ticket.id} />
      <div className="mb-5">
        {" "}
        Observações Para o Montador:
        <TextArea
          rows={4}
          onChange={(e) => setObservation(e.target.value)}
          value={observation}
        />
      </div>
      <Comment ticketInfo={ticket} schedule />
      <div className="flex justify-between">
        {onCancel && <Button onClick={onCancel}>Cancelar</Button>}

        <Button
          type="primary"
          onClick={() =>
            scheduleTicket(
              ticket,
              eventDate,
              ownerId,
              observation,
              quilometragem
            )
          }
        >
          Agendar
        </Button>
      </div>
    </>
  );
};

export default ScheduleAssembleEvent;
